export const backgroundColors = {
  elm: "bg-primary-500",
  putty: "bg-putty-100",
  "putty-300": "bg-putty-300",
  fern: "bg-secondary-500",
};

export const textColors = {
  elm: "text-white",
  fern: "text-white",
  putty: "text-primary-500",
  "putty-300": "text-primary-500",
};

export const dividerColors = {
  elm: "bg-white",
  fern: "bg-white",
  putty: "bg-putty-400",
  "putty-300": "bg-primary-500",
  white: "bg-putty-400",
};
